<template>
  <div>
    <loader v-if="loading"></loader>
    <div v-else>
      <h5 class="title">
        لطفا ساعات کاری مجموعه خود را طبق جدول زیر مشخص کنید.
      </h5>
      <vs-row>
        <div class="tbl-cont">
          <table>
            <th style="border-top: 1px solid lightgray">روز</th>
            <td
              style="
                border-top: 1px solid lightgray;
                background-color: cadetblue;
                color: white;
              "
            >
              بازه
            </td>
            <tr v-for="(item, index) in hours" :key="index">
              <th>{{ getWeekDays(item.day) }}</th>
              <div v-if="item.hour.length > 0">
                <td v-for="(element, i) in item.hour" :key="i">
                  {{ element.from }} - {{ element.to }}
                </td>
                <td>
                  <vs-button
                    @click="selectTimespan(item, index)"
                    color="primary"
                    type="filled"
                    size="small"
                    icon-pack="feather"
                    icon="icon-edit"
                  />
                </td>
              </div>
              <td v-else>
                <vs-button
                  @click="selectTimespan(item, index)"
                  color="primary"
                  size="small"
                  >انتخاب بازه</vs-button
                >
              </td>
            </tr>
          </table>
        </div>
      </vs-row>

      <div v-if="hourModalVisibile">
        <vs-popup title="ساعت کاری" :active.sync="hourModalVisibile">
          <hour-modal
            :timespan="selectedTimespan"
            @timeConfiremd="timeConfiremd"
            :data="hours"
            :hourId="hourId"
          ></hour-modal>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { weekDays } from "../../helpers/Date";
import providerApiService from "../../services/api/ProviderApiService";
import HourModal from "./HourModal.vue";

export default {
  name: "WorkingHours",
  components: {
    HourModal,
  },
  data() {
    return {
      selectedTimespan: null,
      selectedDayIndex: null,
      hourModalVisibile: false,
      hourId: null,
      loading: false,
      hours: [
        { day: 1, hour: [] },
        { day: 2, hour: [] },
        { day: 3, hour: [] },
        { day: 4, hour: [] },
        { day: 5, hour: [] },
        { day: 6, hour: [] },
        { day: 7, hour: [] },
      ],
    };
  },
  methods: {
    fetchData() {
      this.loading = true;
      providerApiService
        .getProviderHours(this.currentProvider.id)
        .then((result) => {
          this.hourId = result.id;
          for (let i = 0; i < this.hours.length; i++) {
            for (let j = 0; j < result.details.length; j++) {
              if (this.hours[i].day === result.details[j].day) {
                this.hours[i].hour = result.details[j].hour;
              }
            }
          }
        })
        .finally(() => (this.loading = false));
    },
    selectTimespan(item, index) {
      this.selectedTimespan = item; // Reset selectedTimespan for adding new timespan
      this.selectedDayIndex = index; // Assign selected day index
      this.toggleHourModalVisibility();
    },
    toggleHourModalVisibility() {
      this.hourModalVisibile = !this.hourModalVisibile;
    },
    timeConfiremd(hours, hourId) {
      this.toggleHourModalVisibility();
      this.hourId = hourId;
      this.hours[this.selectedDayIndex].hour = [...hours];
    },
    getWeekDays(day) {
      return weekDays[day - 1];
    },
  },
  mounted() {
    this.fetchData();
  },
  destroyed() {},
  computed: mapGetters({
    currentProvider: "profile/currentProvider",
  }),
};
</script>

<style scoped lang="scss">
.title {
  font-weight: bold;
  margin: 0 35px 30px;
}

.tbl-cont {
  display: flex;
  margin-bottom: 50px;
  margin-left: 50px;
}

table {
  display: table;
  border-spacing: 0;
}

th {
  text-align: center;
  border: 1px solid lightgray;
  border-top: 0;
  border-right: 1px solid lightgray;
  font-size: 1rem;
  padding: 15px 0;
  min-width: 100px;
  background-color: cadetblue;
  color: white;
  font-weight: normal;
}

td {
  text-align: center;
  min-width: 100px;
  padding: 15px 10px;
  border-bottom: 1px solid lightgray;
  border-right: 1px solid lightgray;
}

tr td:last-child {
  width: 1%;
  white-space: nowrap;
}

button {
  margin: auto;
}
</style>
